const IconLocked = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="6.51831"
                y="13.4849"
                width="16.9633"
                height="11.0152"
                rx="2.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M15 17.9303L15 20.0545"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M19.5713 13.5863L19.5713 9.66095C19.5713 6.94871 17.3726 4.75 14.6603 4.75V4.75C11.9481 4.75 9.7494 6.94871 9.7494 9.66095L9.7494 13.5863"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default IconLocked;
